"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './TabTitle.module.scss.mjs';
import clsx from 'clsx';
import { TunnelExit } from '@mittwald/react-tunnel';

const TabTitleCollapsed = (props) => {
  const { className, ...rest } = props;
  const rootClassName = clsx(className, styles.tabTitle);
  return /* @__PURE__ */ jsx("div", { ...rest, className: rootClassName, "data-selected": true, children: /* @__PURE__ */ jsx(TunnelExit, { id: "ActiveTitle" }) });
};

export { TabTitleCollapsed, TabTitleCollapsed as default };
//# sourceMappingURL=TabTitleCollapsed.mjs.map
